import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {colorFunctions} from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import AmChartPie from "../../components/AmChartPie";
import FloorRow from "../../components/FloorRow";
import {useParams} from "react-router-dom";

import {JWT} from "../../constants/local-storage";

export default function FacilityFloors(){
	
	const facilityId = useParams()["facilityId"];
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();
	
	const [dataSpaceType, setDataSpaceType] = useState([]);
	const [dataCrClass, setDataCrClass] = useState([]);
	const [floors, setFloors] = useState([]);
	
	const breakdownBy = [
		{label:"View area by space type", url:"spacegetallareawithchildrenbyspacetype"},
		{label:"View capacity by space type", url:"spacegetallcapacitywithchildrenbyspacetype"},
		{label:"View area by cr class", url:"spacegetallareawithchildrenbyclassificationitem"},
		{label:"View capacity by cr class", url:"spacegetallcapacitywithchildrenbyclassificationitem"}
	];
	
	useEffect(() => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/facilitygetfloors?facilityId=" + facilityId, setFloors, analyseFloors);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/facilitygettotalareabyspacetype?facilityId=" + facilityId, setDataSpaceType, null);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/facilitygettotalareabyclassificationitem?facilityId=" + facilityId, setDataCrClass, null);
	}, [facilityId]);
	
	const analyseFloors = (input) => {
		console.log(input);
	};
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	minheight:"100vh",
  	left:"60px",
  	top:"90px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"80px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
 
	
	const thisContent = {
		display:"flex",
		width:"100%",
		height:"100%",
		backgroundColor:"white"
	};
	
	const chartContainer = {
	  display: "flex",
	  width: "300px",
	  flexDirection: "column",
	  alignItems: "center",
	  height: "100%",
	  background: "linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%)",
	  borderRight: "1px solid rgba(0,0,0,0.06)"
	};
	
	const chartLabel = {
		display:"flex",
		width:"100%",
		alignItems:"center",
		justifyContent:"space-around",
		minHeight:"40px",
		fontSize:'14px',
		fontWeight:"bold"
	};
	
	
	const stackContainer = {
		display:"flex",
		width:"calc(100% - 300px)",
		flexDirection:"column",
		height:"100%",
		overflow:"auto"
	};
	
	const stackSelectContainer = {
		display:"flex",
		minHeight:"80px",
		width:"100%",
		justifyContent:"space-around"
	};
	
	const floorRowDisplay = floors.map((item, index) =>
		<FloorRow
			id={index}
			name={item.name}
			area={item.areaReportable}
			facilityId={facilityId}
		/>
	);
	
	const stackButtonContainer = {
		display:'flex',
		margin:"20px",
		alignSelf:"center",
		minHeight:"30px"
	};
	
	const stackButtonSpaceType = {
		display:'flex',
		height:'100%',
		width:"240px",
		color:'white',
		fontSize:'14px',
		alignItems:"center",
		justifyContent:"space-around",
		cursor:'pointer',
		backgroundColor:"darkgrey",
		borderRadius:"15px"
	};
	
	const stackButtonOrganisation = {
		display:'flex',
		height:'100%',
		width:"240px",
		color:'white',
		fontSize:'14px',
		alignItems:"center",
		justifyContent:"space-around",
		cursor:'pointer',
		backgroundColor:"darkgreen",
		borderRadius:"15px",
		marginLeft:"-30px"
	};
	
	const breakdownSelector = {
 		display:"flex",
 		width:"500px",
 		height:"30px",
 		border:"2px solid lightgrey",
 		paddingLeft:"10px",
 		margin:"20px",
 		alignSelf:"center",
 		borderRadius:"18px"
 	};
 	
 	const handleBreakdownSelectChange = (e) => {
 		
 	};
 	
 	const breakdownSelectOptions = breakdownBy.map((item, index) => 
 		<option value={index}>
 			{item.label}
 		</option>
 	);
 	
	return (
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>	
				<div style={mainContainer}>
						<div style={thisContent}>
								<div style={chartContainer}>
									<div style={chartLabel}>
										Area by Space Type
									</div>
									<AmChartPie
										chartId="facilityfloorspiespacetype"
										width="200px"
										height="200px"
										chartData={dataSpaceType}
										categoryKey="name"
										valueKey="value"
									/>
									<div style={chartLabel}>
										Area by CR Class
									</div>
									
									<AmChartPie
										chartId="facilityfloorspieorganisation"
										width="200px"
										height="200px"
										chartData={dataCrClass}
										categoryKey="name"
										valueKey="value"
									/>
								</div>
								<div style={stackContainer}>
									<div style={stackSelectContainer}>
										<select style={breakdownSelector} onChange={handleBreakdownSelectChange}>
											{breakdownSelectOptions}
										</select>
									</div>
									{floorRowDisplay}
								</div>
							</div>
						</div>
					
			</div>
	);
}